import { useFormikContext } from 'formik';
import React from 'react';
import { CheckboxInput } from 'ui-toolkit';
import { IStandardDocumentData } from 'types/order/documents/shared/interfaces';
import { IMergeDocumentValues } from './MergeDocumentForm';

export interface ISelectDocumentToMerge {
  document: IStandardDocumentData;
}

export const SelectDocumentToMerge: React.FC<ISelectDocumentToMerge> = ({ document }) => {
  const formik = useFormikContext<IMergeDocumentValues>();
  // eslint-disable-next-line

  const selected = (documentId: string) => formik.values.selectedDocuments.some((d) => d.id === documentId);

  const onChange = (value: boolean) => {
    const currentValue = (formik.values as IMergeDocumentValues).selectedDocuments;
    formik.setFieldTouched('selectedDocuments');

    formik.setFieldValue(
      'selectedDocuments',
      value ? [...currentValue, document] : currentValue.filter((doc) => doc.id !== document.id)
    );
  };
  return <CheckboxInput value={selected(document.id)} onChange={onChange} />;
};
